import * as types from "../actionTypes.js";
import { unionWith, isEqual } from "lodash";

export const trades = (state = { loaded: false, data: [] }, action) => {
  switch (action.type) {
    // case types.LOADING_TRADES:
    //   return { ...state, loaded: false };
    case types.TRADES_LOADED:
      return { ...state, loaded: true, data: action.trades };
    case types.TRADE_ADDED:
      return { ...state, data: unionWith(state.data, [action.newTrade], isEqual) };
    default:
      return state;
  }
};

export const lpTrades = (state = { loaded: false, data: [] }, action) => {
  switch (action.type) {
    // case types.LOADING_LP_TRADES:
    //   return { ...state, loaded: false };
    case types.LP_TRADES_LOADED:
      return { ...state, loaded: true, data: action.trades };
    case types.LP_TRADE_ADDED:
      return { ...state, data: unionWith(state.data, [action.newTrade], isEqual) };
    default:
      return state;
  }
};

// account liquidation trades (penalties and rewards)
export const liquidationTrades = (state = { loaded: false, data: [] }, action) => {
  switch (action.type) {
    case types.LIQUIDATION_TRADES_LOADED:
      return { ...state, loaded: true, data: action.trades };
    case types.LIQUIDATION_TRADE_ADDED:
      return { ...state, data: unionWith(state.data, [action.newTrade], isEqual) };
    default:
      return state;
  }
};

export const allTrades = (state = { loaded: false, data: [] }, action) => {
  switch (action.type) {
    // case types.LOADING_TRADES:
    //   return { ...state, loaded: false };
    case types.ALL_TRADES_LOADED:
      return { ...state, loaded: true, data: action.trades };
    case types.ALL_TRADE_ADDED:
      return { ...state, data: unionWith(state.data, [action.newTrade], isEqual) };
    default:
      return state;
  }
};

export const allLpTrades = (state = { loaded: false, data: [] }, action) => {
  switch (action.type) {
    // case types.LOADING_LP_TRADES:
    //   return { ...state, loaded: false };
    case types.ALL_LP_TRADES_LOADED:
      return { ...state, loaded: true, data: action.trades };
    case types.ALL_LP_TRADE_ADDED:
      return { ...state, data: unionWith(state.data, [action.newTrade], isEqual) };
    default:
      return state;
  }
};
